import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Subscription } from 'rxjs';

export class ClinicalFeedbackFile {
    id: string;
    name: string;
    size: number;
    extension: string;
    uploadProgress = 0;
    subscription = Subscription.EMPTY;
    error = {
        onUpload: false,
        fileSize: false,
        fileType: false,
        fileContent: false,
        fileAmount: false
    };
    uploading = false;
    success = false;
    progressBarColor: ThemePalette = 'primary';
    progressBarMode: ProgressBarMode = 'determinate';

    constructor(data: { id: string; name: string; size: number; extension: string }) {
        this.id = data.id;
        this.name = data.name;
        this.size = data.size;
        this.extension = data.extension;
    }
}
